<template>
  <main class="main about max-width">
    <article>
      <h1 class="title-medium">Lettera di attestazione SIAE</h1>

      <p>Mettiamo a disposizione la lettera di attestazione per la Licenza S.I.A.E. di Edizioni Caramba, numero 1690/I/1740. Questo documento ti permetterà di utilizzare i contenuti dei nostri artisti in diverse situazioni, quali
      </p><ul>
        <li>la programmazione delle opere musicali da parte di emittenti radiofoniche o web radio</li>
        <li>l'esecuzione nei locali pubblici da parte di DJ</li>
        <li>giornalismo o blogging</li>
        <li>attività di promozione dell'utilizzo dei brani musicali da parte di agenzie pubblicitarie</li>
      </ul><p></p>

      <p><a href="https://s3.eu-central-1.amazonaws.com/caramba-it/media/lettera-attestazione-siae.pdf" download target="_blank" rel="external noopener nofollow" class="button button-regular button-aqua button-anim">Scarica la lettera di attestazione</a></p>
    </article>
  </main>
</template>

<script>
export default {
  name: 'Lettera Attestazione Siae',

  mounted() {
    document.title = 'Caramba - Lettera Attestazione Siae';
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/components/LetteraAttestazioneSiae.vue